// Trata 401 renovando o token Auth0 e re-tentando a request UMA vez.
// Single-flight: N requests 401 simultaneas (polling) disparam UMA renovacao.
// Se a renovacao falhar, redireciona ao login em vez de seguir martelando a API.
import { getInstance } from "../auth0-plugin";

let renewing = null;

export function attachAuth0Retry(axiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error.config;
      const status = error.response && error.response.status;
      if (status !== 401 || !config || config._auth0Retried) {
        return Promise.reject(error);
      }
      config._auth0Retried = true;

      const auth0 = getInstance();
      if (!auth0 || !auth0.getAccessTokenSilently) return Promise.reject(error);

      try {
        renewing = renewing || auth0.getAccessTokenSilently({ cacheMode: "off" });
        const token = await renewing;
        renewing = null;
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
        return axiosInstance.request(config);
      } catch (e) {
        renewing = null;
        try {
          await auth0.loginWithRedirect({
            appState: { targetUrl: window.location.pathname + window.location.search },
          });
        } catch (_) { /* pagina segue para o login */ }
        return new Promise(() => {}); // navegacao em curso; suspende a cadeia
      }
    }
  );
  return axiosInstance;
}

